import * as React from "react";
import { Card, Text, makeStyles, tokens } from "@fluentui/react-components";
import {
  Circle24Regular,
  ArrowSync24Regular,
  ErrorCircle24Regular,
  CheckmarkCircle24Regular,
} from "@fluentui/react-icons";
import { useTypographyStyles } from "../../../styles/typography.styles";

const useStyles = makeStyles({
  container: {
    display: "flex",
    gap: tokens.spacingHorizontalXL,
    flexWrap: "wrap",
  },
  card: {
    padding: tokens.spacingVerticalM,
    display: "flex",
    flexDirection: "row",
    gap: tokens.spacingHorizontalS,
    alignItems: "center",
    flex: "1 1 auto",
    cursor: "pointer",
    transition: "transform 0.1s ease, box-shadow 0.1s ease",
    ":hover": {
      transform: "translateY(-2px)",
      boxShadow: tokens.shadow8,
    },
    ":active": {
      transform: "translateY(0)",
    },
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
  },
  toDoIcon: {
    backgroundColor: "#F3F2F1",
    color: "#8A8886",
  },
  inProgressIcon: {
    backgroundColor: "#E1F5FE",
    color: "#0078D4",
  },
  incompleteIcon: {
    backgroundColor: "#FDE7E9",
    color: "#D73B02",
  },
  completeIcon: {
    backgroundColor: "#E8F5E9",
    color: "#107C10",
  },
});

interface TaskStatisticsProps {
  toDoCount: number;
  inProgressCount: number;
  incompleteCount: number;
  completeCount: number;
  onStatusClick: (status: string) => void;
}

const TaskStatistics: React.FC<TaskStatisticsProps> = ({
  toDoCount,
  inProgressCount,
  incompleteCount,
  completeCount,
  onStatusClick,
}) => {
  const styles = useStyles();
  const typography = useTypographyStyles();

  return (
    <div className={styles.container}>
      <Card className={styles.card} onClick={() => onStatusClick("to_do")}>
        <div className={`${styles.iconContainer} ${styles.toDoIcon}`}>
          <Circle24Regular />
        </div>
        <Text className={typography.statNumber}>{toDoCount}</Text>
        <Text className={typography.statLabel}>To Do</Text>
      </Card>

      <Card className={styles.card} onClick={() => onStatusClick("in_progress")}>
        <div className={`${styles.iconContainer} ${styles.inProgressIcon}`}>
          <ArrowSync24Regular />
        </div>
        <Text className={typography.statNumber}>{inProgressCount}</Text>
        <Text className={typography.statLabel}>In Progress</Text>
      </Card>

      <Card className={styles.card} onClick={() => onStatusClick("incomplete")}>
        <div className={`${styles.iconContainer} ${styles.incompleteIcon}`}>
          <ErrorCircle24Regular />
        </div>
        <Text className={typography.statNumber}>{incompleteCount}</Text>
        <Text className={typography.statLabel}>Incomplete</Text>
      </Card>

      <Card className={styles.card} onClick={() => onStatusClick("complete")}>
        <div className={`${styles.iconContainer} ${styles.completeIcon}`}>
          <CheckmarkCircle24Regular />
        </div>
        <Text className={typography.statNumber}>{completeCount}</Text>
        <Text className={typography.statLabel}>Complete</Text>
      </Card>
    </div>
  );
};

export default TaskStatistics;
